import { loadScript } from '@landing/official-common/utils'

export default function polyfill() {
  if ('IntersectionObserver' in window) {
    return Promise.resolve()
  }
  return loadScript('https://polyfill.io/v3/polyfill.min.js?features=IntersectionObserver')
}
